<div fxLayout fxLayoutGap="24px" fxLayoutAlign="space-between center" class="elm-app-header">
  <ng-content select="elm-app-logo"></ng-content>

  <ng-content select="elm-app-header-actions"></ng-content>
</div>
<ng-content select="elm-app-header-content"></ng-content>
